import React from 'react';
import styles from './progress-bar.module.scss';

export interface Props extends React.HTMLAttributes<HTMLDivElement> {
  value: number;
  height?: number;
  color?: 'primary' | 'success';
  hideBackground?: boolean;
}

export const ProgressBar = (props: Props) => {
  const { value, height = 4, hideBackground = false, className, ...rest } = props;
  const mergedClassName = [styles['progress-bar'], className].filter(Boolean).join(' ');

  return (
    <div
      className={mergedClassName}
      role="progressbar"
      aria-valuemin={0}
      aria-valuemax={100}
      aria-valuenow={value}
      style={{
        ['--progress-bar-height' as string]: `${height}px`,
        ['--progress-bar-bg' as string]: hideBackground ? 'transparent' : undefined,
        ['--progress-bar-translate' as string]: `translateX(${value - 100}%)`
      }}
      {...rest}
    >
      <div className={styles['inner-bar']} />
    </div>
  );
};

export default React.memo(ProgressBar);
